module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "center1 display_column"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "200px",
      "margin-bottom": "10px"
    }
  }, [_c('Checkbox', {
    on: {
      "on-change": _vm.GetTableData
    },
    model: {
      value: (_vm.mytask.flag),
      callback: function($$v) {
        _vm.$set(_vm.mytask, "flag", $$v)
      },
      expression: "mytask.flag"
    }
  }, [_vm._v("我的任务")]), _vm._v(" "), _c('span', [_vm._v("【")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#FF6600",
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.mytask.content) + "条")]), _vm._v(" "), _c('span', [_vm._v("】")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.mytask.flag),
      expression: "!this.mytask.flag"
    }]
  }, [_c('div', {
    staticClass: "display_row_js"
  }, [_c('div', {
    staticClass: "center1_1 dispaly_flex00"
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "search": "",
      "placeholder": "输入项目名称"
    },
    on: {
      "on-search": _vm.GetTableData,
      "on-enter": _vm.GetTableData
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "display_row_ac",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "85px",
      "height": "30px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": function($event) {
        return _vm.GetTableData('1')
      }
    },
    model: {
      value: (_vm.yeartime),
      callback: function($$v) {
        _vm.yeartime = $$v
      },
      expression: "yeartime"
    }
  }, _vm._l((_vm.yearList), function(year) {
    return _c('Option', {
      attrs: {
        "value": year.PROYEAR
      }
    }, [_vm._v("\n                " + _vm._s(year.PROYEAR) + "\n              ")])
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "display_row_js",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dcinfo),
      expression: "dcinfo"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "display_row_ac"
  }, [_c('Select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "filterable": "",
      "size": "small"
    },
    on: {
      "on-change": function($event) {
        return _vm.GetTableData('1')
      }
    },
    model: {
      value: (_vm.dwid),
      callback: function($$v) {
        _vm.dwid = $$v
      },
      expression: "dwid"
    }
  }, _vm._l((_vm.dwList), function(dw) {
    return _c('Option', {
      key: dw.value,
      attrs: {
        "value": dw.value
      }
    }, [_vm._v(_vm._s(dw.label))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "display_row_ac"
  }, [_c('Select', {
    staticStyle: {
      "width": "85px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": function($event) {
        return _vm.GetTableData('1')
      }
    },
    model: {
      value: (_vm.stateid),
      callback: function($$v) {
        _vm.stateid = $$v
      },
      expression: "stateid"
    }
  }, _vm._l((_vm.stateList), function(sl) {
    return _c('Option', {
      key: sl.value,
      attrs: {
        "value": sl.value
      }
    }, [_vm._v(_vm._s(sl.label))])
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "display_row_js_ac",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "display_row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "display_row_ac",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_c('CheckboxGroup', {
    on: {
      "on-change": _vm.GetTableData
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('Checkbox', {
      key: item.label,
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center1_1xj display_row_je"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewPro && _vm.prjend),
      expression: "addNewPro && prjend"
    }],
    staticClass: "gcbtndiv display_row_ac",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.adddata
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../../../../static/images/ic_new_02.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("新建申报项目")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dcinfo),
      expression: "dcinfo"
    }],
    staticClass: "gcbtndiv display_row_ac",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.daochu
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../../../../static/images/ic_export.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("导出")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onSriolly),
      expression: "onSriolly"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "center1_2 dispaly_flex11"
  }, _vm._l((_vm.listData), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "Maintenance_Event_nr",
      class: {
        Maintenance_Event_nrbxz: item.active == true && item.top == true,
          Maintenance_Event_nrxz: item.active == false && item.top == true,
          Maintenance_Event_nryy: item.top == false
      },
      attrs: {
        "flag": item.active
      },
      on: {
        "click": function($event) {
          return _vm.changestyle(i, item)
        }
      }
    }, [_c('div', {
      staticClass: "display_row_js Maintenance_Event_nr_1 media_w_w18"
    }, [_c('div', {
      staticClass: "display_row_ac"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.active),
        expression: "!item.active"
      }],
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": require("../../../../static/images/ic_engineering_01.png")
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.active),
        expression: "item.active"
      }],
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": require("../../../../static/images/ic_engineering_02.png")
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.PRJNAME))])]), _vm._v(" "), _c('div', {
      staticClass: "display_row_je_ac media_w_w14"
    }, [_c('div', {
      class: {
        STEPNAME_sty: item.top == false
      },
      staticStyle: {
        "background": "#80bb80",
        "width": "90px",
        "text-align": "center"
      }
    }, [_c('span', [_vm._v(_vm._s(item.STEPNAME))])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(item.STEP == 24)),
        expression: "!(item.STEP == 24)"
      }],
      staticClass: "display_row_je",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          (item.STEP >= 8 && item.STEP <= 12) ||
          (item.STEP >= 18 && item.STEP <= 20) ||
          item.STEP == 13 ||
          (item.STEP >= 25 && item.STEP <= 28 && item.STEP != 27) ||
          item.STEP == 23
        ),
        expression: "\n              (item.STEP >= 8 && item.STEP <= 12) ||\n                (item.STEP >= 18 && item.STEP <= 20) ||\n                item.STEP == 13 ||\n                (item.STEP >= 25 && item.STEP <= 28 && item.STEP != 27) ||\n                item.STEP == 23\n            "
      }]
    }, [_c('Tooltip', {
      attrs: {
        "content": item.STEP >= 8 && item.STEP <= 13 ?
          '合同下载' :
          item.STEP >= 15 && item.STEP <= 21 ?
          '验收资料下载' :
          '验收小结下载'
      }
    }, [_c('img', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": _vm.url.url4
      },
      on: {
        "click": function($event) {
          return _vm.ht_download(i, item, $event)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(item.STEP == 5)),
        expression: "!(item.STEP == 5)"
      }]
    }, [_c('Tooltip', {
      attrs: {
        "content": "操作"
      }
    }, [_c('img', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": _vm.url.url3
      },
      on: {
        "click": function($event) {
          return _vm.caozuo(i, item, $event)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !(item.STEP == 5) &&
          item.CREATEUSER == _vm.createuser &&
          !(item.STEP > 7)
        ),
        expression: "\n              !(item.STEP == 5) &&\n                item.CREATEUSER == createuser &&\n                !(item.STEP > 7)\n            "
      }]
    }, [_c('Tooltip', {
      attrs: {
        "content": "修改"
      }
    }, [_c('img', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": _vm.url.url1
      },
      on: {
        "click": function($event) {
          return _vm.xiugai(i, item, $event)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(item.STEP > 5) && _vm.expertinfo != 1),
        expression: "!(item.STEP > 5) && expertinfo != 1"
      }]
    }, [_c('Tooltip', {
      attrs: {
        "content": "删除"
      }
    }, [_c('img', {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "src": _vm.url.url2
      },
      on: {
        "click": function($event) {
          return _vm.delprj(item)
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "Maintenance_Event_nr_3",
      attrs: {
        "id": item.guid
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', [_c('Modal', {
    attrs: {
      "title": "审核"
    },
    model: {
      value: (_vm.model_dw),
      callback: function($$v) {
        _vm.model_dw = $$v
      },
      expression: "model_dw"
    }
  }, [_c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.modal_cancel_a
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.modal_chushen
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('Row', [_c('span', [_vm._v("审核状态：")]), _vm._v(" "), _c('RadioGroup', {
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: (_vm.STEPID),
      callback: function($$v) {
        _vm.STEPID = $$v
      },
      expression: "STEPID"
    }
  }, _vm._l((_vm.sh_state_3), function(sh) {
    return _c('Radio', {
      key: sh.value,
      attrs: {
        "label": sh.value
      }
    }, [_vm._v("\n            " + _vm._s(sh.label) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "modal_ty"
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('span', [_vm._v("审核意见：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请填写审核意见"
    },
    model: {
      value: (_vm.sh_opinion),
      callback: function($$v) {
        _vm.sh_opinion = $$v
      },
      expression: "sh_opinion"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "600",
      "title": "审核"
    },
    model: {
      value: (_vm.model_ylj),
      callback: function($$v) {
        _vm.model_ylj = $$v
      },
      expression: "model_ylj"
    }
  }, [_c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.modal_yljshenhe
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_modal),
      expression: "flag_modal"
    }]
  }, [_c('div', [_c('Row', [_c('Col', {
    staticClass: "weight_f",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("专家意见：")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "type": "info",
      "disabled": _vm.isdisabledFn
    },
    on: {
      "click": _vm.add_zjinfo
    }
  }, [_vm._v("添加专家")])], 1)], 1), _vm._v(" "), _c('Row', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_a),
      expression: "!show_a"
    }],
    staticClass: "sty_a"
  }, [_c('Col', {
    staticClass: "media_w_w16",
    staticStyle: {
      "height": "50px",
      "margin-top": "25px"
    }
  }, [_c('span', [_vm._v("请先添加专家")])])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_a),
      expression: "show_a"
    }],
    staticStyle: {
      "max-height": "450px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.data_zj_a), function(info, index) {
    return _c('div', {
      key: index,
      staticClass: "modal_sty"
    }, [_c('Row', [_c('Col', {
      staticClass: "media_w_w18",
      staticStyle: {
        "margin-top": "8px",
        "padding-left": "10px"
      },
      attrs: {
        "span": "17"
      }
    }, [_vm._v("\n                " + _vm._s(info.USERNAME) + "\n                "), _c('span', [_vm._v("(" + _vm._s(info.DWMC) + ")")])]), _vm._v(" "), _c('Col', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.pf_show),
        expression: "pf_show"
      }],
      staticClass: "media_w_w16",
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "5px"
      },
      attrs: {
        "span": "5"
      }
    }, [_c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v("评分：")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(info.GRADENUM))])], 1)], 1), _vm._v(" "), _c('Row', {
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "0px"
      }
    }, [_c('Col', {
      staticStyle: {
        "margin-left": "10px",
        "margin-bottom": "5px"
      },
      attrs: {
        "span": "2"
      }
    }, [_vm._v("意见：")]), _vm._v(" "), _c('Col', {
      staticStyle: {
        "margin-left": "4px",
        "margin-bottom": "5px"
      },
      attrs: {
        "span": "19"
      }
    }, [_vm._v("\n                " + _vm._s(info.GRADEADIVCE) + "\n              ")])], 1)], 1)
  }), 0), _vm._v(" "), _c('div', [_c('Row', {
    staticClass: "modal_ty"
  }, [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('span', {
    staticClass: "weight_f"
  }, [_vm._v("审核状态：")]), _vm._v(" "), _c('RadioGroup', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "on-change": _vm.tip_info
    },
    model: {
      value: (_vm.STEPID),
      callback: function($$v) {
        _vm.STEPID = $$v
      },
      expression: "STEPID"
    }
  }, _vm._l((_vm.sh_state_3), function(sh) {
    return _c('Radio', {
      key: sh.value,
      attrs: {
        "label": sh.value,
        "disabled": _vm.isReadOnly
      }
    }, [_vm._v(_vm._s(sh.label))])
  }), 1)], 1), _vm._v(" "), _c('span', [_c('Button', {
    attrs: {
      "size": "small",
      "type": "default"
    },
    on: {
      "click": _vm.clear_info
    }
  }, [_vm._v("清除")])], 1)])])], 1), _vm._v(" "), _c('Row', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.STEPID != '6'),
      expression: "STEPID != '6'"
    }],
    staticClass: "modal_ty"
  }, [_c('Col', {
    staticClass: "weight_f",
    attrs: {
      "span": "4"
    }
  }, [_c('span', [_vm._v("审核意见：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请填写审核意见",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.sh_opinion_ylj),
      callback: function($$v) {
        _vm.sh_opinion_ylj = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "sh_opinion_ylj"
    }
  })], 1)], 1)]), _vm._v(" "), _c('Row', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.STEPID == '6'),
      expression: "STEPID == '6'"
    }],
    staticClass: "modal_ty"
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('span', [_c('div', {
    staticClass: "weight_f",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("项目编号：")])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入项目编号",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.ht_number_ylj),
      callback: function($$v) {
        _vm.ht_number_ylj = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ht_number_ylj"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.typeid),
      callback: function($$v) {
        _vm.typeid = $$v
      },
      expression: "typeid"
    }
  }, _vm._l((_vm.Type), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1)])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flag_modal),
      expression: "!flag_modal"
    }]
  }, [_c('div', [_c('Row', [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "12px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.zj_name),
      callback: function($$v) {
        _vm.zj_name = $$v
      },
      expression: "zj_name"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('span', [_vm._v("单位")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "12px"
    },
    attrs: {
      "placeholder": "请输入单位"
    },
    model: {
      value: (_vm.zj_dw),
      callback: function($$v) {
        _vm.zj_dw = $$v
      },
      expression: "zj_dw"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-top": "0px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.getzj_info
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "350px",
      "max-height": "450px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.data_zj), function(info) {
    return _c('div', {
      staticClass: "modal_sty_a"
    }, [_c('Row', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('Col', {
      staticStyle: {
        "margin-left": "15px",
        "margin-top": "13px"
      },
      attrs: {
        "span": "1"
      }
    }, [_c('Checkbox', {
      model: {
        value: (info.zj_check),
        callback: function($$v) {
          _vm.$set(info, "zj_check", $$v)
        },
        expression: "info.zj_check"
      }
    })], 1), _vm._v(" "), _c('Col', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "span": "21"
      }
    }, [_c('Row', {
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "5px"
      }
    }, [_c('Col', {
      staticClass: "weight_f",
      attrs: {
        "span": "12"
      }
    }, [_vm._v("专家姓名：" + _vm._s(info.USERNAME))]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "12"
      }
    }, [_vm._v("所属单位：" + _vm._s(info.DWMC))])], 1), _vm._v(" "), _c('Row', {
      staticStyle: {
        "margin-top": "5px",
        "margin-bottom": "8px"
      }
    }, [_c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_vm._v("科研方向：")]), _vm._v(" "), _c('Col', {
      staticStyle: {
        "margin-left": "-12px"
      },
      attrs: {
        "span": "19"
      }
    }, [_vm._v("\n                    " + _vm._s(info.REMARK) + "\n                  ")])], 1)], 1)], 1)], 1)
  }), 0)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "专家评审"
    },
    on: {
      "on-ok": _vm.modal_ok_zjdf,
      "on-cancel": _vm.modal_cancel
    },
    model: {
      value: (_vm.model_zjdf),
      callback: function($$v) {
        _vm.model_zjdf = $$v
      },
      expression: "model_zjdf"
    }
  }, [_c('Row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zjdf_show),
      expression: "zjdf_show"
    }]
  }, [_c('span', [_vm._v("专家评分：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "margin-left": "7px",
      "width": "83%"
    },
    attrs: {
      "placeholder": "0~100分",
      "type": "number"
    },
    model: {
      value: (_vm.zjdf_value),
      callback: function($$v) {
        _vm.zjdf_value = $$v
      },
      expression: "zjdf_value"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('div', {
    staticClass: "modal_ty"
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('span', [_vm._v("专家意见：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请填写审核意见"
    },
    model: {
      value: (_vm.sh_opinion),
      callback: function($$v) {
        _vm.sh_opinion = $$v
      },
      expression: "sh_opinion"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "信息上传"
    },
    model: {
      value: (_vm.model_scht),
      callback: function($$v) {
        _vm.model_scht = $$v
      },
      expression: "model_scht"
    }
  }, [_c('div', [_c('Row', [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_vm._v(_vm._s(_vm.titlename) + "上传：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Upload', {
    ref: "uploadfile",
    attrs: {
      "action": _vm.fileAction,
      "before-upload": _vm.handleUpload,
      "multiple": _vm.show_htinfo
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.updata(this)
      }
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": "上传",
      "placement": "top"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-cloud-upload-outline"
    }
  }, [_vm._v("上传")])], 1)], 1)])], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pronumber.length != 0),
      expression: "pronumber.length != 0"
    }],
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "10"
    }
  }, [_vm._v("项目编号：" + _vm._s(_vm.pronumber))])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.modal_cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modal_ok_scht
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "录入时间信息",
      "width": "400"
    },
    on: {
      "on-ok": _vm.modal_ok_lrTime,
      "on-cancel": _vm.modal_cancel
    },
    model: {
      value: (_vm.model_lrTime),
      callback: function($$v) {
        _vm.model_lrTime = $$v
      },
      expression: "model_lrTime"
    }
  }, [_c('div', [_c('span', [_vm._v("\n          中期时间:\n          "), _c('DatePicker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.zq_time),
      callback: function($$v) {
        _vm.zq_time = $$v
      },
      expression: "zq_time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('span', [_vm._v("\n          验收时间:\n          "), _c('DatePicker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.ys_time),
      callback: function($$v) {
        _vm.ys_time = $$v
      },
      expression: "ys_time"
    }
  })], 1)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "收件"
    },
    on: {
      "on-ok": _vm.modal_ok,
      "on-cancel": _vm.modal_cancel
    },
    model: {
      value: (_vm.model_sj),
      callback: function($$v) {
        _vm.model_sj = $$v
      },
      expression: "model_sj"
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('span', [_vm._v("园林局收件：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": "确认收件",
      "placement": "top"
    }
  }, [_c('Button', {
    on: {
      "click": _vm.modal_ok_sj
    }
  }, [_vm._v("确认收件")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "验收申请"
    },
    on: {
      "on-ok": _vm.modal_ok,
      "on-cancel": _vm.modal_cancel
    },
    model: {
      value: (_vm.model_yssq),
      callback: function($$v) {
        _vm.model_yssq = $$v
      },
      expression: "model_yssq"
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('span', [_vm._v("单位验收申请：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": "确认申请",
      "placement": "top"
    }
  }, [_c('Button', {
    on: {
      "click": _vm.modal_ok_yssq
    }
  }, [_vm._v("确认申请")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "项目完结"
    },
    on: {
      "on-ok": _vm.modal_ok,
      "on-cancel": _vm.modal_cancel
    },
    model: {
      value: (_vm.model_xmwj),
      callback: function($$v) {
        _vm.model_xmwj = $$v
      },
      expression: "model_xmwj"
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('span', [_vm._v("项目信息：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": "项目完结",
      "placement": "top"
    }
  }, [_c('Button', {
    on: {
      "click": _vm.modal_ok_xmwj
    }
  }, [_vm._v("项目完结")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核"
    },
    on: {
      "on-ok": _vm.modal_ok_cxtj,
      "on-cancel": _vm.modal_cancel
    },
    model: {
      value: (_vm.model_cxtj),
      callback: function($$v) {
        _vm.model_cxtj = $$v
      },
      expression: "model_cxtj"
    }
  }, [_c('Row', [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('span', [_vm._v("信息提交：")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('div', [_c('Button', [_vm._v("是否重新提交")])], 1)])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "40px",
      "height": "30px"
    }
  }, [_c('span', [_vm._v("年份")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "35px"
    }
  }, [_c('span', [_vm._v("单位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "40px"
    }
  }, [_c('span', [_vm._v("状态")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("类别")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6db1096a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/theme/center/center.vue
// module id = 1077
// module chunks = 1